export const focusRing =
  'outline-hidden focus-visible:outline-solid outline-2 outline-green-500 outline-offset-2'

export const peerFocusRing =
  'outline-hidden outline-offset-2 peer-focus-visible:outline-solid outline-2 outline-green-500'
